export default function preparationGraph({ graphComponentRef, graphModel, clearGraph, documentObjects, nodesSource = {}, edgesSource = {}, groups = {} }) {
    var _a;
    const graph = (_a = graphComponentRef === null || graphComponentRef === void 0 ? void 0 : graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph;
    if (!graph) {
        throw new Error("Ошибка анализа JSON: граф не найден");
    }
    if (!graphModel) {
        throw new Error("Ошибка анализа JSON: graphModel не найдена");
    }
    if (clearGraph) {
        graph.clear();
    }
    return {
        graphComponentRef,
        jsonGraphModel: graphModel,
        graph,
        groups,
        nodesSource,
        documentObjects,
        edgesSource,
        nodeMap: new Map(),
        edgeMap: new Map()
    };
}
